export const SLP_ITEMS_PER_PAGE = 18; // It must be a multiple of 3 and 2

export const ACCOUNT_GRID_LISTING_ITEMS_PER_PAGE = 12; // It must be a multiple of 3 and 2

export const ACCOUNT_ROW_LISTING_ITEMS_PER_PAGE = 10;

export const FIRST_PAGE = 1;

export const FE_PAGE_PARAM = 'page';
